import { skipToken, useQuery } from '@tanstack/react-query';

import { type GetRelatedFeaturesPayload, getRelatedFeatures } from '~/services/PromoService';

export const relatedFeatureQueryKeys = {
  all: ['promo-related-features'] as const,
  list: (payload: GetRelatedFeaturesPayload) => [...relatedFeatureQueryKeys.all, payload] as const,
};

export function useGetRelatedFeatures(payload: GetRelatedFeaturesPayload | null) {
  return useQuery({
    queryKey: payload ? relatedFeatureQueryKeys.list(payload) : relatedFeatureQueryKeys.all,
    queryFn: payload ? ({ signal }) => getRelatedFeatures(payload, { signal }) : skipToken,
    enabled: payload !== null,
  });
}
